import { ThreatsBreakdownController } from '../controller/ThreatsBreakdownController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class ThreatsBreakdownWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ThreatsBreakdownController,
    });
  }
}
